<!--第三方产品字典-->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ThirdDictionaryManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">

        <div class="addButton">
          <el-button type="primary" @click="operateDialog('add')">添加</el-button>
        </div>

        <el-table
          v-loading="loading"
          :data="deviceList"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="code"
            label="产品ID"
            width="250">
          </el-table-column>
          <el-table-column
            prop="name"
            label="产品名称"
            width="80">
          </el-table-column>
          <el-table-column
            label="产品密钥">
            <template slot-scope="scope">
              <el-button type="text" @click="LookKey(scope.row)" v-if="scope.row.type == '5'">查看</el-button>
              <span v-else>/</span>
              <!-- <a :href="scope.row.url" target="_blank">{{scope.row.url}}</a> -->
            </template>
          </el-table-column>
          <el-table-column
            label="账号">
            <template slot-scope="scope">
              <span>{{scope.row.type == 5 ? '/' : scope.row.username}}</span>
              <!-- <a :href="scope.row.url" target="_blank">{{scope.row.url}}</a> -->
            </template>
          </el-table-column>
          <el-table-column
            label="密码">
            <template slot-scope="scope">
              <el-button type="text" @click="LookKey(scope.row)" v-if="scope.row.type == '6'">查看</el-button>
              <span v-else>/</span>
              <!-- <a :href="scope.row.url" target="_blank">{{scope.row.url}}</a> -->
            </template>
          </el-table-column>
          <el-table-column
            label="第三方平台">
            <template slot-scope="scope">
              <!-- 1柜类 2门禁 3其它 4无人仓 5 OneNet 6视频云 -->
              <span>{{typeList[scope.row.type]}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="device_num"
            label="设备数量">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="operateDialog('alter', scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="paging" v-if="paging.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="paging.page"
            layout="prev, pager, next, jumper"
            :page-count="paging.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">

          <!-- 添加或修改产品 -->
          <div>
            <el-form
              label-width="120px"
              :model="dialogData.info"
              ref="updateForm">
              <template v-if="dialogData.type === 'add'">
              <el-form-item label="第三方平台:" prop="type" :rules="[{ required: true, message: '第三方平台不能为空'}]">
                <el-select class="inputDeposit" v-model="dialogData.info.type" placeholder="请选择第三方平台">
                  <el-option
                    v-for="(item, index) in typeList"
                    :key="index"
                    :label="item"
                    :value="index">
                  </el-option>
                </el-select>
              </el-form-item>
              </template>
              <template v-else>
              <el-form-item label="第三方平台:">
                <p>{{typeList[dialogData.info.type]}}</p>
              </el-form-item>
              </template>
              <!-- OneNet显示 -->
              <template v-if="dialogData.type === 'add' && dialogData.info.type == 5">
              <el-form-item label="产品密钥:" prop="access_key" :rules="[{ required: true, message: '产品密钥不能为空'}]">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.access_key"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="产品id:" prop="code" :rules="[{ required: true, message: '产品id不能为空'}]">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.code"></el-input>
                </div>
              </el-form-item>
              </template>
              <!-- 视频云显示 -->
              <template v-if="dialogData.info.type == 6">
              <el-input style="position:fixed;bottom:-9999px"></el-input>
              <el-input type="password" style="position:fixed;bottom:-9999px"></el-input>
              <el-form-item label="账号:" prop="username" :rules="[{ required: true, message: '账号不能为空'}]">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.username"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="密码:" prop="password" :rules="[{ required: true, message: '密码不能为空'}]">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password"></el-input>
                </div>
              </el-form-item>
              </template>
              <el-form-item label="产品名称:" prop="name" :rules="[{ required: true, message: '产品名称不能为空'}]">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取消</el-button>
              <el-button type="primary" @click="submitUpdateForm('updateForm')">确 认</el-button>
            </div>
          </div>
        </el-dialog>

        <!-- 查看产品密钥 -->
        <el-dialog
          class="LookKeyDio"
          :title="akeyVerify ? '' : '身份验证'"
          :visible.sync="LookKeyDio"
          width="500px">
            <div class="keyBox" v-if="akeyVerify">
              <p class="title">{{LookKeyType == 5 ? '产品密钥' : '密码'}}</p>
              <p class="access_key" id="access_key">{{LookKeyType == 5 ? access_key : password}}</p>
              <p class="copyText" @click="copyKey">复制</p>
            </div>
            <template v-else>
              <p class="user_account">登录用户： {{accountInfo.user_account}}</p>
              <el-input placeholder="请输入密码验证身份" v-model="accountInfo.password" show-password></el-input>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogData.visible = false">取消</el-button>
                <el-button @click="userLogin">确认</el-button>
              </div>
            </template>
        </el-dialog>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { localUserInfo, showToast, deepCopy, copyText } from "../../../../static/js/utility/utility.js"
  import { loginApi, systemApi } from "../../../../static/js/api.js"
  let vm

  export default {
    name: 'ThirdDictionaryManage',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 分页数据  page为当前页，perPage为每页数量 
        paging: {
          page: 1,
          perPage: 10,
          pageCount: ''
        },

        typeList: {
          '5': 'OneNet',
          '6': '视频云'
        },
        // 第三方应用列表
        deviceList:[],
        loading: false,

        // 查看产品密钥/密码
        LookKeyDio: false,
        LookKeyType: '', 
        accountInfo: {
          user_account: localUserInfo.getItem().user_account,
          password: ''
        },
        access_key: '', // 密钥
        password: '', // 密码
        akeyVerify: '',
      }
    },
    created () {
      vm = this
      vm.akeyVerify = localUserInfo.getItem().akeyVerify === undefined ? false : localUserInfo.getItem().akeyVerify
    },
    mounted(){
      vm.getDeviceList()
    },
    methods: {
      // 当前页值改变，获取新的第三方应用列表
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        vm.getDeviceList()
      },
      // 获取列表
      getDeviceList: async function () {
        let data = {
          page: vm.paging.page,
          perPage: vm.paging.perPage,
          category: 3
        }

        vm.loading = true
        let res = await systemApi.getDeviceList(data)
        vm.loading = false
        if (res.meta.code === 200) {
          vm.deviceList = res.data
          vm.paging.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },

      /** 更新（添加修改） */
      // 操作（添加或修改）dialogData
      operateDialog: function (type, info) {
        let addInfo
        if (type === 'add') {
          addInfo = {
            access_key: '' ,
            code: '',
            type: '',
            username: '',
            password: '',
            name: ''
          }
        }
        vm.dialogData = {
          type: type,
          title: type === 'add' ? '添加产品' :
                  type === 'alter' ? '修改产品' :
                  type === 'authentication' ? '身份验证' : '',
          visible: !(vm.dialogData.visible),
          info: type === 'add' ? addInfo : info ? deepCopy(info) : ''
        }
        console.log('vm', vm.dialogData)

        if (type === 'add') {
          setTimeout(() => {
            vm.$refs['updateForm'].resetFields()
          })
        }
      },
      // 提交添加/修改表单
      submitUpdateForm(formName) {
        this.$refs[formName].validate((valid, data) => {
          if (valid) {
            vm.updateDevice()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 更新（添加/修改）
      updateDevice: async function () {
        let data = {
          name: vm.dialogData.info.name,
          category: 3
        }
        if (vm.dialogData.type === 'add' && vm.dialogData.info.type == 5) {   // OneNet-添加
          data.type = vm.dialogData.info.type
          data.access_key = vm.dialogData.info.access_key
          data.code = vm.dialogData.info.code
        }
        if (vm.dialogData.type === 'alter' && vm.dialogData.info.type == 5) { // OneNet-修改
          data.device_id = vm.dialogData.info.device_id
        }
        if (vm.dialogData.info.type == 6) { // 云视频
          data.type = vm.dialogData.info.type
          data.username = vm.dialogData.info.username
          data.password = vm.dialogData.info.password
          if (vm.dialogData.type === 'alter') { data.device_id = vm.dialogData.info.device_id }  // 云视频-修改
        }
        console.log('data', data)
        // return

        let res = await systemApi.updateDevice(data)
        if (res.meta.code === 200) {
          showToast(vm.dialogData.type === 'add' ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(this.dialogData.visible)
          vm.getDeviceList()
        } else {
          showToast(res.meta.message)
        }
      },

      /** 查看密钥 */
      // 点击查看密钥
      LookKey (info) {
        vm.accountInfo.id = info.device_id
        vm.LookKeyDio = true
        vm.LookKeyType = info.type
        if (vm.akeyVerify) {
          vm.getAccessKey()
        } else {
          vm.accountInfo.password = ''
        }
      },
      // 身份验证
      async userLogin() {
        let data = {
          user_account: vm.accountInfo.user_account,
          password: vm.accountInfo.password
        }
        if(data.password === '') {
          showToast('请输入密码验证身份')
          return
        }
        let res = await loginApi.userLogin(data)
        if (res.meta.code === 200) {
          showToast('验证成功')
          vm.akeyVerify = true
          let userInfo = localUserInfo.getItem()
          localUserInfo.setItem(userInfo)
          console.log('userInfo', userInfo)
          vm.getAccessKey()
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取密钥
      async getAccessKey () {
        let data = {
          id: vm.accountInfo.id
        }
        let res = await systemApi.getAccessKey(data)
        if (res.meta.code === 200) {
          if (vm.LookKeyType == 5) { // OneNet查看密钥
            vm.access_key = res.data.access_key
          } else if (vm.LookKeyType == 6) { // 视频云查看密码
            vm.password = res.data.password
          }
          console.log('access_key', vm.access_key)
        } else {
          showToast(res.meta.message)
        }
      },
      // 复制密钥
      copyKey () {
        copyText('access_key').then(function () {
          showToast('复制成功')
        })
        // setTimeout(() => {
        //   vm.LookKeyDio = false
        // }, 500)
      },
    },
    watch: {
      // 监听vuex的值变化
      "userInfo":async function(newVal, oldVal) {
        console.log('newVal', newVal)
      }
    }
  }
</script>

<style lang="scss" scoped>
.addButton {
  margin-bottom: 20px;
}
.LookKeyDio {
  .user_account {
    margin-bottom: 10px;
  }
  .keyBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .title {
      width: 100%;
      line-height: 30px;
      border-bottom: 1px solid #f0f0f0;
      color: #cccccc;
    }
    .access_key{
      line-height: 40px;
    }
    .copyText{
      color: #409EFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/System/ThirdDictionaryManage.vue